// extracted by mini-css-extract-plugin
export default {"caret":"panelheader_caret__9vPl9"};